import type { RecentlyViewedContentType } from '@/home/recently_viewed'

type EventNamePerContentType = Record<RecentlyViewedContentType, string>

export const RECENTLY_VIEWED_EVENT_NAMES = {
  SELECTED_TAB: {
    goals: 'Selected Recently Viewed Goals',
    strategies: 'Selected Recently Viewed Strategies',
    resources: 'Selected Recently Viewed Resources'
  },
  CLICKED_VIEW_MORE: {
    goals: 'Clicked View More Recently Viewed Goals',
    strategies: 'Clicked View More Recently Viewed Strategies',
    resources: 'Clicked View More Recently Viewed Resources'
  },
  CLICKED_BROWSE: {
    goals: 'Clicked Browse Goals',
    strategies: 'Clicked Browse Strategies',
    resources: 'Clicked Browse Assessments'
  }
} satisfies Record<string, EventNamePerContentType>
